<template>
  <div class="CascadeRegion">
    <template v-if="cascadeOptions.length">
      {{ getModel(rowData).model.join('/') }}
      <br />
      <el-cascader
        ref="cascaderRef"
        class="cascaderRef"
        :props="props"
        v-model="getModel(rowData).model"
        @change="onChangeValue"
      ></el-cascader>
    </template>
  </div>
</template>

<script>
import { getCascaderRegion } from '@/api/preview'
import { itemInitOptions } from '../config/config.js'
import { saveArr } from '../public/index.js'

let firstRegion = null
export default {
  name: 'CascadeRegion',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    const self = this
    return {
      cascadeOptions: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          if (level === 0) {
            resolve(self.cascadeOptions)
          } else {
            if (node.data.next === 0) {
              resolve([])
            } else {
              self.getCascade(node.data.regionCode).then(resolve)
            }
          }
        },
        label: 'regionName',
        value: 'regionCode'
      }
    }
  },
  methods: {
    onChangeValue() {
      let nodes = this.$refs.cascaderRef.getCheckedNodes()
      let results = []
      for (let i = 0, len = nodes.length; i < len; i++) {
        let node = nodes[i]
        node.path.forEach((code, index) => {
          results.push(
            Object.assign({}, itemInitOptions, {
              optionId: code,
              value: node.pathLabels[index]
            })
          )
        })
      }
      this.rowData.items = results
      this.saveArr()
    },
    getCascade(pid) {
      return new Promise((resolve, reject) => {
        getCascaderRegion(pid).then(res => {
          let data = res.data.data
          if (!pid) {
            this.cascadeOptions = firstRegion = this.transformCascadeRegion(data)
            // 第一次设置
            this.setValue()
          } else {
            resolve(this.transformCascadeRegion(data))
          }
        })
      })
    },
    transformCascadeRegion(data = []) {
      let results = []
      for (let i = 0, len = data.length; i < len; i++) {
        let item = data[i]
        if (item.next) {
          // TODO
        } else {
          item.leaf = true
        }
        results.push(item)
      }
      return results
    },
    // saveArr() {
    //   const existIdx = this.updateArr.findIndex((item) => {
    //     return item.questonId === this.rowData.questonId
    //   })
    //   if(existIdx === -1) { //添加
    //     this.updateArr.push(this.rowData)
    //   }
    // },
    setValue() {
      this.$nextTick(() => {
        if (document.getElementsByClassName('cascaderRef')[0]) {
          let node = document.getElementsByClassName('cascaderRef')[0].children[0].children[0]
          node.value = this.getModel(this.rowData).label.join('/')
        }
      })
    },
    saveArr
  },
  computed: {
    getModel() {
      return function (row) {
        let valArr = []
        let labelArr = []

        if (row.items.length > 1) {
          row.items.forEach(element => {
            valArr.push(element.optionId)
            labelArr.push(element.value)
          })
        }
        return {
          model: valArr,
          label: labelArr
        }
      }
    }
  },
  created() {
    if (firstRegion) {
      this.cascadeOptions = firstRegion
    } else {
      this.getCascade()
    }
  },
  mounted() {
    // 第二次进
    this.setValue()
  }
}
</script>

<style lang="scss" scoped>
.cascaderRef {
  width: 100%;
}
.CascadeRegion .el-cascader--medium {
  width: 400px;
}
</style>
